<sharry-header></sharry-header>
<div class="contacts">
  <section>
    <article>
      <h1>{{ 'contacts.title' | i18next }}</h1>
      <p class="bigger">{{ 'contacts.subtitle' | i18next }}</p>
      <div class="contacts__boxes">
        <div class="contacts__box">
          <div class="contacts__box__icon">
            <sharry-icon name="house-line"></sharry-icon>
          </div>
          <p
            class="bigger"
            style="margin-bottom: -24px">
            {{ 'contacts.info-1' | i18next }}
          </p>
          <p class="bigger semibold">{{ 'contacts.info-2' | i18next }}</p>
          <div
            style="margin-left: -5px"
            class="contacts__box__quote"></div>
          <p class="contacts__box__quotation">{{ 'contacts.info-3' | i18next }}</p>
          <a
            class="bigger anchor"
            [routerLink]="'what-is-sharryland' | routeTranslate"
            >{{ 'contacts.go-profile' | i18next }}</a
          >
        </div>
        <div class="contacts__box">
          <div class="contacts__box__icon">
            <sharry-icon name="map-trifold"></sharry-icon>
          </div>
          <a
            class="bigger"
            href="https://www.google.it/maps/place/Piazza+Facchetti+Faustino,+12,+35013+Cittadella+PD/@45.6504023,11.7815025,17z/data=!3m1!4b1!4m5!3m4!1s0x4778d44ee43bd917:0x290c3e5558c69400!8m2!3d45.6504023!4d11.7836912"
            [innerHTML]="'contacts.address' | i18next"></a>
          <button
            class="bigger sharry-simple"
            (click)="onTel('+393356013413')">
            +39 335 6013413
          </button>
          <a
            class="bigger anchor"
            (click)="scrollToFrom()"
            >{{ 'contacts.send-message' | i18next }}</a
          >
        </div>
        <div class="contacts__box">
          <div class="contacts__box__icon">
            <sharry-icon name="scales"></sharry-icon>
          </div>
          <small class="semibold">{{ 'contacts.cod-fis' | i18next }}</small>
          <p class="bigger">05096140289</p>
          <small class="semibold">{{ 'contacts.rea' | i18next }}</small>
          <p class="bigger">PD-442705</p>
          <small class="semibold">{{ 'contacts.sdi' | i18next }}</small>
          <p class="bigger">SUBM70N</p>
          <small class="semibold">{{ 'contacts.pec' | i18next }}</small>
          <button
            class="bigger sharry-simple"
            (click)="onMailto('legal@pec.sharry.land')">
            legal&#64;pec.sharry.land
          </button>
        </div>
      </div>
    </article>
  </section>
  <section id="form-section">
    <article>
      <h2>{{ 'contacts.form.title' | i18next }}</h2>
      <p
        class="bigger"
        [innerHTML]="'contacts.form.subtitle' | i18next"></p>
      <form
        class="contacts__form"
        [formGroup]="contactsForm"
        (ngSubmit)="onSubmit()">
        <label for="name">{{ 'contacts.form.name' | i18next }}*</label>
        <mat-form-field
          appearance="outline"
          id="name-field">
          <input
            matInput
            sharryFormScroll
            type="text"
            id="name"
            formControlName="name" />
          @if (contactsForm.get('name')?.dirty && contactsForm.get('name')?.errors?.required) {
            <mat-error>
              {{ 'form-validation.required' | i18next }}
            </mat-error>
          }
        </mat-form-field>
        <label for="businessName">{{ 'contacts.form.businessName' | i18next }}</label>
        <mat-form-field
          appearance="outline"
          id="businessName-field">
          <input
            matInput
            sharryFormScroll
            type="text"
            id="businessName"
            formControlName="businessName" />
        </mat-form-field>
        <label for="role">{{ 'contacts.form.role' | i18next }}*</label>
        <mat-form-field
          appearance="outline"
          id="role-field">
          <mat-select
            id="role"
            sharryFormScroll
            formControlName="role">
            @for (option of roleOptions; track option) {
              <mat-option [value]="option.key">{{ option.value }}</mat-option>
            }
            <mat-option [value]="contactsRoleOthers">{{ 'contacts.role.other' | i18next }}</mat-option>
          </mat-select>
          @if (contactsForm.get('role')?.dirty && contactsForm.get('role')?.errors?.required) {
            <mat-error>
              {{ 'form-validation.required' | i18next }}
            </mat-error>
          }
        </mat-form-field>
        <label for="city">{{ 'contacts.form.city' | i18next }}</label>
        <mat-form-field
          appearance="outline"
          id="city-field">
          <input
            matInput
            sharryFormScroll
            type="text"
            id="city"
            formControlName="city" />
        </mat-form-field>
        <label for="message">{{ 'contacts.form.message' | i18next }}*</label>
        <mat-form-field
          appearance="outline"
          id="message-field">
          <textarea
            matInput
            sharryFormScroll
            id="message"
            rows="3"
            formControlName="message"></textarea>
          @if (contactsForm.get('message')?.dirty && contactsForm.get('message')?.errors?.required) {
            <mat-error>
              {{ 'form-validation.required' | i18next }}
            </mat-error>
          }
        </mat-form-field>
        <label for="surname">{{ 'contacts.form.surname' | i18next }}*</label>
        <mat-form-field
          appearance="outline"
          id="surname-field">
          <input
            matInput
            sharryFormScroll
            type="text"
            id="surname"
            formControlName="surname" />
          @if (contactsForm.get('surname')?.dirty && contactsForm.get('surname')?.errors?.required) {
            <mat-error>
              {{ 'form-validation.required' | i18next }}
            </mat-error>
          }
        </mat-form-field>
        <label for="email">{{ 'contacts.form.email' | i18next }}*</label>
        <mat-form-field
          appearance="outline"
          id="email-field">
          <input
            matInput
            sharryFormScroll
            type="email"
            id="email"
            formControlName="email" />
          @if (contactsForm.get('email')?.dirty && contactsForm.get('email')?.errors?.required) {
            <mat-error>
              {{ 'form-validation.required' | i18next }}
            </mat-error>
          }
        </mat-form-field>
        <label for="request">{{ 'contacts.form.request' | i18next }}*</label>
        <mat-form-field
          appearance="outline"
          id="request-field">
          <mat-select
            id="request"
            sharryFormScroll
            formControlName="request">
            @for (option of requestOptions; track option) {
              <mat-option [value]="option.key">{{ option.value }}</mat-option>
            }
            <mat-option [value]="contactsRequestOthers">{{ 'contacts.request.others' | i18next }}</mat-option>
          </mat-select>
          @if (contactsForm.get('request')?.dirty && contactsForm.get('request')?.errors?.required) {
            <mat-error>
              {{ 'form-validation.required' | i18next }}
            </mat-error>
          }
        </mat-form-field>
        <label for="phone">{{ 'contacts.form.phone' | i18next }}</label>
        <mat-form-field
          appearance="outline"
          id="phone-field">
          <input
            matInput
            sharryFormScroll
            type="text"
            id="phone"
            formControlName="phone" />
        </mat-form-field>
        <mat-checkbox
          id="privacy"
          formControlName="privacy"
          color="primary"
          >{{ 'contacts.form.checkbox' | i18next }}
          <a
            target="__blank"
            [routerLink]="'privacy' | routeTranslate">
            Privacy</a
          ></mat-checkbox
        >
        <small class="contacts__recaptcha"></small>

        <button
          mat-flat-button
          class="sharry-big"
          color="primary"
          type="submit"
          [disabled]="contactsForm.invalid">
          {{ 'contacts.form.submit' | i18next }}
        </button>
      </form>
    </article>
  </section>
</div>

<sharry-footer class="is-not-mobile"></sharry-footer>
